module.exports = __webpack_public_path__ + "static/img/yytx21.721c779.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx21.png
// module id = 800
// module chunks = 0